export default __webpack_public_path__ + "static/1696-8ea9546643f7b8c9551aecb9b30aa440.gif";